import { useState } from "react";
import { RiRobot2Line, RiRefreshLine, RiSendPlaneLine } from "react-icons/ri";

const AIResponseGenerator = ({ context, onSelect }) => {
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const generateSuggestions = async () => {
    setLoading(true);
    try {
      // Mock API call - replace with actual OpenAI API integration
      const response = await new Promise((resolve) =>
        setTimeout(() => {
          const mockSuggestions = [
            {
              id: 1,
              message:
                "Hi there! 👋 We noticed you didn't complete your payment. Need help with the process?",
              tone: "friendly",
              type: "follow_up",
            },
            {
              id: 2,
              message:
                "Quick reminder: Your payment is pending. Click here to complete your purchase securely.",
              tone: "professional",
              type: "reminder",
            },
            {
              id: 3,
              message:
                "Don't miss out! Complete your payment now and get instant access to your purchase.",
              tone: "urgent",
              type: "promotional",
            },
          ];
          resolve(mockSuggestions);
        }, 1000),
      );
      setSuggestions(response);
    } catch (error) {
      console.error("Error generating suggestions:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <RiRobot2Line className="w-5 h-5 text-primary-500" />
          <h3 className="font-medium text-secondary-900">
            AI Response Suggestions
          </h3>
        </div>
        <button
          className="btn btn-secondary flex items-center"
          onClick={generateSuggestions}
          disabled={loading}
        >
          {loading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-2 border-primary-500/30 border-t-primary-500"></div>
          ) : (
            <RiRefreshLine className="w-5 h-5" />
          )}
        </button>
      </div>

      <div className="space-y-3">
        {suggestions.map((suggestion) => (
          <div
            key={suggestion.id}
            className="p-4 rounded-lg border border-secondary-200 hover:border-primary-500 cursor-pointer transition-all"
            onClick={() => onSelect(suggestion.message)}
          >
            <div className="flex justify-between items-start mb-2">
              <span
                className={`text-xs px-2 py-1 rounded-full ${
                  suggestion.tone === "friendly"
                    ? "bg-success-50 text-success-500"
                    : suggestion.tone === "professional"
                      ? "bg-primary-50 text-primary-500"
                      : "bg-warning-50 text-warning-500"
                }`}
              >
                {suggestion.tone.charAt(0).toUpperCase() +
                  suggestion.tone.slice(1)}
              </span>
              <button
                className="text-primary-500 hover:text-primary-600"
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(suggestion.message);
                }}
              >
                <RiSendPlaneLine className="w-5 h-5" />
              </button>
            </div>
            <p className="text-secondary-600">{suggestion.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIResponseGenerator;
